import { writable } from 'svelte/store';

export const f = writable('flips into?');
export const o = writable('obsolesces?');
export const r = writable('retrieves?');
export const e = writable('enhances?');

export const d = writable('');
export const w = writable('https://en.wikipedia.org/wiki/Special:Search/');
export const i = writable('title');
export const s = writable('source or event');

export const more = writable(false);
export const showModal = writable(false);
export const k = writable(false);